import { Modal } from "react-bootstrap";
import { CameraContext } from "../../../CameraContext";
import WebcamCapture from "./Camera";
import { useContext } from "react";

interface CamProp {
    setShowCropModal?: (val: boolean) => void;
    uploadImgAfterCapture?: boolean
    setShowImgModal?: (val: boolean) => void;
    isFriendProfilePicture?: boolean
    isOpen?: boolean;
    setIsOpen?: (value: boolean) => void;
    onCapture?: (file: File) => void;
}

export const WebCamModal: React.FC<CamProp> = ({
    setShowCropModal,
    uploadImgAfterCapture,
    setShowImgModal,
    isFriendProfilePicture,
    isOpen,
    setIsOpen,
    onCapture,
}) => {

    const cameraContext = useContext(CameraContext);
    const cameraIsOpen = isOpen ?? cameraContext.isOpen;

    return (

        <>
            <Modal size="lg" aria-labelledby="contained-modal-title-vcenter" centered show={cameraIsOpen} animation={true}>
                <Modal.Body>
                    <div className="mt-3">
                        <WebcamCapture SetShowCropModal={setShowCropModal} uploadImgAfterCapture={uploadImgAfterCapture} setShowImgModal={setShowImgModal}
                            isFriendProfilePicture={isFriendProfilePicture} isOpen={cameraIsOpen} setIsOpen={setIsOpen}
                            onCapture={onCapture} />
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}
